export const phoneSources = [
  { text: 'LSA (Google Local Service Ads)', label: 'LSA', value: 'lsa', icon: require('@/assets/images/lsa.webp') },
  { text: 'GBP (Google Business Profile)', label: 'GBP', value: 'gbp', icon: require('@/assets/images/reviewplatforms/icons/icon-googlemaps.png') },
  { text: 'Google Ads', label: 'Google Ads', value: 'google_ads', icon: require('@/assets/images/google-ads.svg') },
  { text: 'Facebook Ads', label: 'Facebook Ads', value: 'facebook_ads', icon: require('@/assets/images/reviewplatforms/icons/icon-facebook.png') },
  { text: 'Yelp (yelp.com)', label: 'Yelp', value: 'yelp', icon: require('@/assets/images/reviewplatforms/icons/icon-yelp.png') },
  { text: 'Website (Website Leads)', label: 'Website', value: 'website', icon: 'https://cdn-icons-png.flaticon.com/512/1006/1006771.png' }
];

export const sourceFilterOptions = [
  { text: 'All Sources', value: null, icon: null },
  ...phoneSources.map(source => ({ ...source, text: source.label }))
];

export function phoneSource(value) {
  return phoneSources.find(source => source.value === value) || {
    text: value || 'Unknown source',
    label: value || 'Unknown source',
    icon: phoneSources.find(source => source.value === 'website').icon
  };
}
